import ContentLoader from 'react-content-loader';

const FavouriteLoader = () => (
	<div
		style={{
			width: '100%',
			maxWidth: '950px',
			paddingTop: '16.84%', // (160 / 950) * 100 = 16.84%
			position: 'relative'
		}}>
		<ContentLoader
			speed={2}
			viewBox='0 0 950 160'
			backgroundColor='#f3f3f3'
			foregroundColor='#ecebeb'
			style={{
				position: 'absolute',
				top: 0,
				left: 0,
				width: '100%',
				height: '100%'
			}}>
			<rect x='20' y='14' rx='10' ry='10' width='115' height='115' />
			<rect x='155' y='20' rx='3' ry='3' width='300' height='20' />
			<rect x='155' y='50' rx='3' ry='3' width='180' height='15' />
			<rect x='155' y='70' rx='3' ry='3' width='300' height='15' />
			<rect x='155' y='90' rx='3' ry='3' width='180' height='15' />
			<rect x='155' y='110' rx='3' ry='3' width='180' height='20' />
			<rect x='910' y='20' rx='3' ry='3' width='24' height='24' />
			<rect x='865' y='50' rx='3' ry='3' width='70' height='20' />
			<rect x='770' y='90' rx='10' ry='10' width='167' height='40' />
			<rect x='700' y='90' rx='10' ry='10' width='60' height='40' />
		</ContentLoader>
	</div>
);

export default FavouriteLoader;
